var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bs-wrappe img-box"},[_c('img',{staticClass:"img",attrs:{"src":_vm.imgUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }